var PROGRESS_BAR_VARIANT = {
  PERCENTAGE: 'percentage',
  STEPS: 'steps'
};

export { PROGRESS_BAR_VARIANT };
